<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'Login',
  computed: {
    ...mapState('antagonist', {
      token: state => state.token,
      errors: state => state.errors,
    }),
    ...mapGetters('antagonist', [
      'isLoggedIn',
    ]),
    code: {
        get() {
          return this.token;
        },
        set(value) {
          this.setToken(value);
        },
    },
  },
  methods: {
    ...mapActions('antagonist', [
      'fetchUser',
    ]),
    ...mapMutations('antagonist', [
      'setToken',
    ]),
    login() {
      this.fetchUser()
        .then(() => {
          if (this.isLoggedIn) {
            this.$router.push({ name: 'home' });
          }
        })
    },
  }
};
</script>
<template>
    <div id="login" class="text-center">
        <h1>Logowanie</h1>
        <div class="wrapper text-left">
            <div class="container d-flex flex-column">
                <h2>Zaloguj się przy pomocy kodu</h2>
                <label for="code">Kod</label>
                <input id="code" v-model="code" />
                <div class="errors" v-if="errors.length > 0">
                    <div v-for="error in errors">{{ error }}</div>
                </div>
                <div class="text-center">
                    <button @click="login">
                        Zaloguj
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
